import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_2mvbnj1udh: FaireBrandEntity = {
  token: "b_2mvbnj1udh",
  type: "brand",
  name: "Jordan's Skinny Mixes",
  avatarUrl: "https://cdn.faire.com/fastly/ebf14336cc811c61090232eabde17b1a74b8014c56e6142a9c2e5f53ee2093f9.jpeg",
  bannerUrl: "https://cdn.faire.com/fastly/b75da82b3c7339702ba2b43d2b8abe594e6fa35a57beb7d661bf04506f7908a8.png",
  logoUrl: "https://cdn.faire.com/fastly/ebf14336cc811c61090232eabde17b1a74b8014c56e6142a9c2e5f53ee2093f9.jpeg",
  heroImageUrl: "https://cdn.faire.com/fastly/b75da82b3c7339702ba2b43d2b8abe594e6fa35a57beb7d661bf04506f7908a8.png",
  location: "Clearwater, FL, USA",
  minimumOrderDollars: 50,
  rating: 4.8,
  reviewCount: 1716,
  isInsider: true,
  description: "16 years ago, Jordan started with a simple mission - to create the perfect Skinny Margarita. The outcome was so delicious that she had to share it with friends, family, and eventually, the public. It caught 🔥, and she found herself disrupting the beverage industry with guilt-free ways to enjoy a variety of classic cocktails, barista-style coffee creations, flavored waters and so much more.\n\nToday at Skinny Mixes, we remain a small business fueled by the drive to create products for YOU because of YOU. Your excitement, engagement, and pure love for what we dream up together inspire us every day. We can't wait to see where this journey will take us all next! 💋\n\nPLEASE READ:\nReseller Brand Protection Policy - https://www.skinnymixes.com/pages/reseller-brand-protection-policy",
  meta: {
    source: "api",
    importedAt: "2026-10-12T19:14:02.814Z",
    importedBy: "entity-db-cli"
  }
};
